import { AxiosResponse } from "axios";
import {
  IBookingOrderRequest,
  ICurrentOrder,
  IOrder,
  IOrderLogs,
  IOrderNoteRequest,
  IOrderRewardGroupByUserId,
  IOrderSummary,
  IOrderWithPagignation,
} from "../interface/order";
import { http } from "../utils/http";

export const filterOrdersApi = async (payload: {
  paymentMethod?: string;
  periodId?: string;
  userId?: string;
  userName?: string;
  orderNo?: string;
  status?: string;
  begin?: number;
  end?: number;
  page?: number;
  limit?: number;
  dealerNo?: string;
  type?: "csv";
}): Promise<AxiosResponse<IOrderWithPagignation>> => {
  return await http.get("/v1/admin/orders/filter", payload);
};

export const filterOrderSummaryApi = async (
  periodId: string
): Promise<AxiosResponse<IOrderSummary>> => {
  return await http.get(`/v1/admin/orders/filter/summary/${periodId}`);
};

export const getOrderByIdApi = async (
  id: string
): Promise<AxiosResponse<IOrder>> => {
  return await http.get(`/v1/admin/orders/${id}`);
};

export const getOrderLogsByOrderIdApi = async (
  orderId: string
): Promise<AxiosResponse<IOrderLogs[]>> => {
  return await http.get(`/v1/admin/order-logs/${orderId}`);
};

export const getOrderSummaryDashboardApi = async (
  periodId: string
): Promise<
  AxiosResponse<
    {
      date: string;
      totalOrder: number;
      totalAmount: number;
    }[]
  >
> => {
  return await http.get(`/v1/admin/orders/summary-dashboard/${periodId}`);
};

export const adminConfirmOrderApi = async (payload: {
  id: string;
  status: 0 | 1;
  slip?: string;
  buyer?: string;
}): Promise<AxiosResponse<any>> => {
  return await http.post(`/v1/admin/orders/confirm`, payload);
};

export const dealerCustomOrder = async (payload: {
  id: string;
  status: number;
  slip?: string;
  buyer?: string;
}): Promise<AxiosResponse<any>> => {
  return await http.post(`/v1/admin/orders/custom`, payload);
};

export const adminReturnLotterySetApi = async (
  orderId: string,
  payload: { lotterySetId: string }
): Promise<AxiosResponse<any>> => {
  return await http.post(`/v1/admin/orders/${orderId}/return`, payload);
};

export const findRewardByPeriodIdGroupByUserIdApi = async (
  periodId: string
): Promise<AxiosResponse<IOrderRewardGroupByUserId[]>> => {
  return await http.get(`/v1/admin/orders/history/${periodId}/rewards`);
};

export const getCurrentOrder = async (): Promise<
  AxiosResponse<ICurrentOrder>
> => {
  return await http.get(`/v1/orders/current`);
};

export const bookingOrder = async (
  body: IBookingOrderRequest
): Promise<AxiosResponse<void>> => {
  return await http.post(`/v1/orders/booking`, body);
};

export const returnOrder = async (lotterySetId: string): Promise<void> => {
  return await http.post(`/v1/orders/return`, { lotterySetId });
};

export const confirmOrder = async (): Promise<void> => {
  return await http.post(`/v1/orders/confirm`, null);
};

export const updateNoteOrder = async (
  body: IOrderNoteRequest
): Promise<AxiosResponse<IOrder>> => {
  return await http.post(`/v1/admin/orders/note`, body);
};
